module.exports = __webpack_public_path__ + "static/media/icons.b87b9ba5.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-css/themes/default/assets/fonts/icons.ttf
// module id = 405
// module chunks = 0